if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.onSubmitHandlerMem(this);
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      onSubmitHandlerMem(evt) {
         var memincart =  0;
         var memaddtocart = 0;
    
              fetch(`/cart.js`)
                  .then((response) => response.json())
                  .then((responseText) => {
                    console.log(responseText.items);

                    for (let i = 0; i < responseText.items.length; i++) {
                                if(responseText.items[i].variant_id == 41042699321419){
                                    console.log("Membership already in cart");
                                    memincart = 1;
                                    break;
                                }
                              else{
                                 var mamselector = evt.closest('.product__info-container');
                                //console.log(mamselector);
                                if(mamselector){
                                if(mamselector.querySelector('.txt1').classList.contains('active')){
                                    console.log("Membership neecd to added in cart");
                                    memaddtocart = 1;
                                }
                                }
                              }                      
                    }

                    
                    if(memaddtocart==1 && memincart==0)
                    {
                        const config = fetchConfig('javascript');
                        config.headers['X-Requested-With'] = 'XMLHttpRequest';
                        delete config.headers['Content-Type'];
                        const formData = new FormData();
                        formData.append('quantity',1);
                        formData.append('id', '41042699321419');
                        config.body = formData;
                        fetch(`${routes.cart_add_url}`, config)
                        .then((response) => response.text())
                        .then((response) => {
                                  fetch(`${routes.cart_url}?section_id=cart-drawer`)
                                    .then((response) => response.text())
                                    .then((responseText) => {
                                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                                      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                                      for (const selector of selectors) {
                                        const targetElement = document.querySelector(selector);
                                        const sourceElement = html.querySelector(selector);
                                        if (targetElement && sourceElement) {
                                          targetElement.replaceWith(sourceElement);
                                        }
                                      }
                                    })
                                    .catch((e) => {
                                      console.error(e);
                                    });
                        })
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                  });
      }
      

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
